import "core-js";
import "babel-polyfill";

import misc from "./classes/misc";
import lotteryTabs from "./classes/lotteryTabs";
import styleSelect from "./classes/styleSelect";
import radioLabel from "./classes/radioLabel";
import timer from "./classes/timer";
import authentication from "./classes/authentication";
import registration from "./classes/registration";
import lotteries from "./classes/lotteries";
import lotteryGame from "./classes/lotteryGame";
import lotteryQuickPlay from "./classes/lotteryQuickPlay";
import lotteryResults from "./classes/lotteryResults";
import checkout from "./classes/checkout.js";
import global from "./classes/global";
import support from "./classes/support";
import account from "./classes/account.js";
import unsubscribeNotifications from "./classes/unsubscribe.js";
import depositFunds from "./classes/depositFunds";
import withdrawFunds from "./classes/withdrawFunds";
import managePayments from "./classes/managePayments";
import cardFlip from "./classes/lotteryCard";
import syndicate from "./classes/syndicate";
import matchedTicket from "./classes/matchedTicket";
import blueshyftLocations from "./classes/blueshyftLocations";
import news from "./classes/news";
import winners from "./classes/homepageWinners";
import competitions from "./classes/competitions";


document.addEventListener("DOMContentLoaded", function() {
    timer.init();
    misc.init();
    radioLabel.init();
    authentication.init();
    registration.init();
    lotteries.init();
    lotteryGame.init();
    lotteryQuickPlay.init();
    lotteryResults.init();
    checkout.init();
    account.init();
    unsubscribeNotifications.init();
    depositFunds.init();
    withdrawFunds.init();
    managePayments.init();
    global.init();
    support.init();
    cardFlip.init();
    styleSelect.init("select");
    lotteryTabs.init();
    syndicate.init();
    matchedTicket.init();
    blueshyftLocations.init();
    news();
    winners();
    competitions();
});


// WEBPACK FOOTER //
// ./assets/src/js/scripts.js